import axios,{AxiosResponse} from "axios";
import configs from "../../configs/config";
import { ActionType, snackbar } from "../../redux/actions/Snackbars";
import intl from "react-intl-universal";
import ticketStatusAdd from "../../redux/actions/SystemManagement/TicketStatus";

export const url = `${configs.BASE_URL}/Division`;
const deleteUrl = `${configs.BASE_URL}/Division/permanent/delete/`;
const bulkUpdate = `${configs.BASE_URL}/Division/status/change?ids=`;

export const getDivision = async () => {
  try {
    const tickets = await axios.get(url);
      console.log("api is called",tickets.data);
      return tickets.data;

  } catch (e) {
      console.log(e)
  }
}
export const DivisionAdd = async (data: any) => {
  try {
   let s =  await axios.post(`${configs.BASE_URL}/Division`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return s


  } catch (error:any) {
    if (error.data) {
     
      return {
        isError:true,
        message:error.data
      }
    }  
  }
};

export const updateDivision = async (data: any, id: any,) => {
  try {
    let s = await axios.put(`${url}/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("updateDivision success bro", s)
    return s
  } catch (error:any) {
    if (error.data) {
      console.log("this is error of update",error.data)

      return {
        isError:true,
        message:error.data
      }
    }  

  }
  
}

export const singleDivision = (id: any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios.get(`${url}/${id}`);
      dispatch({
        type: "singleAssetStatus",
        payload: response,
      });
    } catch (error) {
      return console.log(error);
    }
  };
};




export const multipalUpdateDivision = async (data: any, ids: any,status:any) => {
  
  
  try {
    let result = await axios.delete(`${bulkUpdate}${ids}&status=${status}`, data);
    console.log("bulk delete",result)
    
   if (result.status==200){
    return true
    
   }
   else{
    return false
   }
  }  catch (error:any) {
    if (error.response) {
     
      return error.response.data
    }  
  }
};


export const softDeleteDivision = async (id: any) => {
  {
    try {
      let result = await axios.delete(`${bulkUpdate}${id}`);
      
     if (result.status==200){
      return true
      
     }
     else{
      return false
     }
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
}
export const changeDivision = async (id: any, status:boolean) => {
  {
    try {
      let result = await axios.delete(`${configs.BASE_URL}/Division/status/change?ids=${id}&status=${status}`);
      
     if (result.status==200){
      return true
      
     }
     else{
      return false
     }
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
}

export const deleteDivision = async(id: any) => {
  {
    try {
      let s =  await axios.delete(`${deleteUrl}${id}`);
      
      console.log("result after calling AssetStatusAdd", s)

      return s.data
    }  catch (error:any) {
      if (error.response) {
       
        return error.response.data
      }  
    }
  };
};
export const SnackBar =(msg: any,severity:string)=>{
  return async (dispatch: any) => {

  dispatch({
    type: ActionType.SNACKBAR,
    payload: {
      message: msg,
      severity: severity,
      open: true,
    },
  });
}
}

export const loading = (status: any) => {
  return {
    type: "loading",
    payload: status,
  };
};

export default DivisionAdd;